import { InjectionToken } from '@angular/core';

/**
 * Commit semantics of the surface hosting an editor (protocols glossary:
 * Stage / Persist). An editor that STAGES accepts its edits into the opener's
 * draft without persisting anything; an editor that PERSISTS writes the draft
 * to the backend. The confirm-button label tracks this: stage → "Continue",
 * persist → "Save".
 */
export type EditorCommitMode = 'stage' | 'persist';

/**
 * How a both-way editor (method-type, pipeline, resource) learns its commit
 * mode from its host. Dialog wrappers provide `'stage'` at their component
 * providers; page hosts provide nothing and inherit the `'persist'` default,
 * so a forgotten declaration degrades to the historical "Save" label rather
 * than a new lie. The token rides the element-injector chain, so every dialog
 * level in a nested stack gets its mode from its own wrapper.
 */
export const EDITOR_COMMIT_MODE = new InjectionToken<EditorCommitMode>('EDITOR_COMMIT_MODE', {
  factory: () => 'persist',
});
